type BackgroundAccessibilitySnapshot = {
	element: HTMLElement;
	hadInert: boolean;
	previousAriaHidden: string | null;
};

export const isolateModalBackground = (modal: HTMLElement | null): (() => void) => {
	if (!modal || typeof document === 'undefined') return () => undefined;
	const snapshots: BackgroundAccessibilitySnapshot[] = [];
	const captured = new Set<HTMLElement>();

	const captureBackgroundSiblings = (activeBranch: HTMLElement): void => {
		const parent = activeBranch.parentElement;
		if (!parent) return;
		Array.from(parent.children).forEach((candidate) => {
			if (
				candidate === activeBranch ||
				!(candidate instanceof HTMLElement) ||
				captured.has(candidate)
			)
				return;
			captured.add(candidate);
			snapshots.push({
				element: candidate,
				hadInert: candidate.hasAttribute('inert'),
				previousAriaHidden: candidate.getAttribute('aria-hidden'),
			});
			candidate.setAttribute('aria-hidden', 'true');
			candidate.setAttribute('inert', '');
		});
		if (parent !== document.body) captureBackgroundSiblings(parent);
	};

	captureBackgroundSiblings(modal);

	return () => {
		[...snapshots].reverse().forEach(({ element, hadInert, previousAriaHidden }) => {
			if (previousAriaHidden === null) element.removeAttribute('aria-hidden');
			else element.setAttribute('aria-hidden', previousAriaHidden);
			if (!hadInert) element.removeAttribute('inert');
		});
	};
};
